import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { AppShell } from "@/components/layout/AppShell";
import { RouteGuard } from "@/components/layout/RouteGuard";
import BlueprintsPage from "@/features/blueprints";

/**
 * Blueprints — the second screen off the legacy tree.
 *
 * contentWidth="full" because the legacy call was
 * <DashboardLayout title={...} fullHeight banner="">. It is one of only three
 * screens that were full-bleed.
 *
 * Like MCPs it had nothing tying it to react-router: no router hooks anywhere in
 * its subtree, no useEffect data fetching in the page itself. The only coupling
 * was the DashboardLayout it rendered, which is now the route's job.
 *
 * The legacy route was declared as "/bluePrints" while both sidebars linked to
 * "/blueprints". That worked because react-router matches case-insensitively —
 * and it keeps working here, because TanStack does too (asserted in seam.test.ts,
 * since old links and bookmarks now depend on it).
 *
 * It still imports MUI in four dialogs (Typography, Input, TextareaAutosize).
 * That is fine and deliberately out of scope: MUI renders perfectly well inside
 * a TanStack route, it is only react-router that does not. Untangling the two
 * concerns in one commit is what makes these migrations risky.
 */
const BlueprintsRoute = () => {
  const { t } = useTranslation();
  return (
    // Mirrors the legacy route exactly: <ProtectedRoute><HideInferenceOnlyRoute>.
    <RouteGuard allow={(p) => !p.isInferenceOnly}>
      <AppShell title={t("blueprints.blueprints")} contentWidth="full">
        <BlueprintsPage />
      </AppShell>
    </RouteGuard>
  );
};

export const Route = createFileRoute("/blueprints")({
  component: BlueprintsRoute,
});
